/* hx-mobile-nav.js — tabs + drill-down for the mobile nav (snippets/hx-mobile-nav.liquid).
   ~1 KB, deferred, no dependencies. Panels slide via CSS on details[open].is-open. */
class HxMobileNav extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (e) => {
      const tab = e.target.closest('[data-hx-tab]');
      if (tab && this.contains(tab)) {
        this.activateTab(tab);
        return;
      }
      const back = e.target.closest('.hx-mnav__back');
      if (back) {
        const details = back.closest('details');
        if (details) this.closeDetails(details);
      }
    });
    /* details[open] -> animate in (CSS transitions on .is-open) */
    this.addEventListener('toggle', (e) => {
      const d = e.target;
      if (d.tagName === 'DETAILS' && d.open) {
        requestAnimationFrame(() => d.classList.add('is-open'));
      }
    }, true);

    /* morph the header burger to X while the menu drawer is open */
    const dlg = document.querySelector('#menu_mobile');
    if (dlg) {
      dlg.addEventListener('toggle', () => {
        document.documentElement.classList.toggle('hx-menu-open', dlg.open);
      });
    }
  }

  activateTab(tab) {
    const key = tab.dataset.hxTab;
    this.querySelectorAll('[data-hx-tab]').forEach((t) =>
      t.setAttribute('aria-selected', t === tab ? 'true' : 'false')
    );
    this.querySelectorAll('[data-hx-panel]').forEach((p) => {
      p.hidden = p.dataset.hxPanel !== key;
    });
    tab.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
  }

  closeDetails(d) {
    d.classList.remove('is-open');
    setTimeout(() => { d.open = false; }, 250);
  }
}
customElements.define('hx-mobile-nav', HxMobileNav);
